import { useAppState } from 'hooks/useAppState';

export const useMessageTemplatesState = () => {
  const { messageTemplatesState } = useAppState();

  return messageTemplatesState;
};
